import * as React from "react";

const IconWhatsApp1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 40}
    height={props.height ?? 40}
    className={props.className}
    style={{ cursor: "pointer" }}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill={props.color1 ?? "#fff"}
      d="m.993 39.007 2.674-9.761a18.8 18.8 0 0 1-2.516-9.417C1.156 9.441 9.608.992 19.995.992c5.04.002 9.77 1.964 13.329 5.524a18.72 18.72 0 0 1 5.514 13.326C38.834 30.23 30.38 38.68 19.995 38.68h-.008a18.8 18.8 0 0 1-9.005-2.293z"
    ></path>
    <path
      fill={props.color1 ?? "#fff"}
      d="M.993 39.503a.495.495 0 0 1-.478-.626l2.62-9.564a19.33 19.33 0 0 1-2.48-9.484C.66 9.17 9.336.496 19.996.496a19.22 19.22 0 0 1 13.68 5.67 19.22 19.22 0 0 1 5.659 13.677c-.004 10.66-8.68 19.333-19.34 19.333-3.164 0-6.295-.782-9.074-2.26l-9.8 2.57a.5.5 0 0 1-.127.017"
    ></path>
    <path
      fill={props.color1 ?? "#fff"}
      d="M19.994.992c5.041.002 9.771 1.965 13.33 5.524a18.72 18.72 0 0 1 5.513 13.327C38.833 30.23 30.38 38.68 19.994 38.68h-.008a18.8 18.8 0 0 1-9.004-2.294l-9.99 2.62 2.675-9.76a18.8 18.8 0 0 1-2.516-9.418C1.156 9.442 9.607.992 19.994.992m0-.992C9.062 0 .164 8.894.158 19.828a19.86 19.86 0 0 0 2.443 9.55L.035 38.746a.99.99 0 0 0 1.21 1.221l9.614-2.52a19.9 19.9 0 0 0 9.128 2.226c10.94 0 19.839-8.895 19.844-19.829a19.7 19.7 0 0 0-5.804-14.028A19.72 19.72 0 0 0 19.994 0"
    ></path>
    <path
      fill={props.color2 ?? "#40C351"}
      d="M31.072 8.765A15.56 15.56 0 0 0 20 4.175c-8.639 0-15.664 7.022-15.668 15.654a15.6 15.6 0 0 0 2.394 8.333l.374.592-1.583 5.778 5.927-1.555.573.34a15.63 15.63 0 0 0 7.971 2.182h.006c8.633 0 15.659-7.024 15.662-15.657a15.56 15.56 0 0 0-4.584-11.077"
    ></path>
    <path
      fill={props.color1 ?? "#fff"}
      fillRule="evenodd"
      d="M15.284 11.954c-.352-.784-.724-.8-1.06-.814-.275-.011-.588-.01-.902-.01s-.824.118-1.256.59c-.431.47-1.648 1.609-1.648 3.925 0 2.317 1.687 4.556 1.922 4.87.236.313 3.258 5.218 8.043 7.106 3.977 1.568 4.787 1.257 5.65 1.178s2.786-1.138 3.178-2.238.392-2.041.275-2.238c-.118-.196-.432-.313-.902-.55-.47-.236-2.786-1.374-3.218-1.53-.431-.158-.745-.236-1.06.235-.313.47-1.215 1.532-1.49 1.845-.275.315-.55.355-1.02.118-.47-.236-1.987-.732-3.787-2.336-1.4-1.247-2.344-2.789-2.619-3.26s-.03-.726.207-.96c.211-.212.47-.55.706-.826.235-.274.314-.47.47-.785.157-.314.08-.59-.039-.824-.116-.236-1.031-2.565-1.45-3.496"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default IconWhatsApp1;
